export default __webpack_public_path__ + "static/media/Article 1.ff697be2.png";